__webpack_require__.p = "/pliki/materialy/aplikacjeWebowe/React/";